<div class="quality-selector relative">
  <button
    type="button"
    class="btn btn-xs bg-base-content/10 border-none text-base-content hover:bg-base-content/20"
    data-testid="video-quality-indicator"
    aria-label="Video quality"
    [attr.aria-expanded]="showMenu"
    [disabled]="!manualSelectionAvailable"
    [attr.title]="manualSelectionAvailable ? 'Choose video quality' : 'Quality is managed automatically by your browser'"
    (click)="toggleMenu()">
    {{ indicatorLabel }}
  </button>

  @if (showMenu) {
    <div class="quality-menu absolute bottom-full right-0 mb-2 bg-base-100 rounded-lg shadow-lg p-2 min-w-max z-50">
      <div class="text-xs opacity-75 mb-2">Video Quality</div>
      <div class="flex flex-col gap-1">
        <button
          type="button"
          class="btn btn-xs border-none hover:bg-base-200"
          data-testid="video-quality-option"
          [class.bg-primary]="selectedLevel === -1"
          [class.text-primary-content]="selectedLevel === -1"
          (click)="selectLevel(-1)">
          Auto
        </button>
        @for (level of levels; track level.index) {
          <button
            type="button"
            class="btn btn-xs border-none hover:bg-base-200"
            data-testid="video-quality-option"
            [class.bg-primary]="selectedLevel === level.index"
            [class.text-primary-content]="selectedLevel === level.index"
            (click)="selectLevel(level.index)">
            {{ level.height }}p
          </button>
        }
      </div>
    </div>
  }
</div>
